export default defineNuxtPlugin({
  name: 'Settings',
  enforce: 'pre',
  hooks: {
    'app:created': async() => {
      const { initSettings, initBranding } = useSettingsStore();
      const { loggedIn } = useUserStore();

      if (loggedIn) {
        return initSettings();
      }
      return initBranding(true);
    },
  },
})